import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

export default defineNuxtPlugin(() => {
    if ("serviceWorker" in navigator) {
        const config = useRuntimeConfig().public;
        const firebaseConfig = {
            apiKey: config.FirebaseApiKey,
            authDomain: config.firebaseAuthDomain,
            projectId: config.firebaseProjectId,
            storageBucket: config.firebaseStorageBucket,
            messagingSenderId: config.firebaseMessagingSenderId,
            appId: config.firebaseAppId,
            measurementId: config.firebaseMeasurementId,
        };
        const app = initializeApp(firebaseConfig);
        const messaging = getMessaging(app);

        // Request Permission to Receive Notifications
        const firebaseToken = ref();
        const requestPermission = async () => {
            try {
                const currentToken = await getToken(messaging, {
                    vapidKey: config.firebaseVapidID,
                });
                if (currentToken) {
                    firebaseToken.value = currentToken;
                } else {
                    console.log("No registration token available. Request permission to generate one.");
                }
            } catch (error) {
                console.log("An error occurred while retrieving token. ", error);
            }
        };

        // Handle Incoming Messages
        onMessage(messaging, (payload) => {
            // Customize notification here
            const notificationTitle = payload.notification?.title;
            const notificationOptions = {
                body: payload.notification?.body,
                icon: payload.notification?.icon,
            };
            new Notification(notificationTitle as string, notificationOptions);
        });
        return {
            provide: {
                firebase: requestPermission,
                token: firebaseToken,
            },
        };
        // nuxtApp.provide("firebase", { requestPermission });
    }
});
